<template>
	<router-view v-if="routeHasParams" :key="$route.fullPath"></router-view>
	<div v-else class="grid-flex-container pa-4">
		<div
			v-if="!isSuperAdmin"
			class="grid-flex-container reportsSection pa-0"
		>
			<h3>Reports - Visible to everyone</h3>
			<v-container
				fluid
				class="flexContainerItem pb-0"
				style="overflow: hidden"
			>
				<div class="d-flex">
					<v-text-field
						v-model="searchReports"
						class="py-0 mr-2"
						append-icon="mdi-magnify"
						label="Search"
						single-line
						hide-details
					/>
				</div>
				<div class="generic-grid-container">
					<v-data-table
						dense
						hide-default-footer
						disable-pagination
						fixed-header
						loading-text="Loading..."
						:items="allVisibleReportPreviews"
						:headers="reportsHeaders"
						:search.sync="searchReports"
						:loading="loading"
					>
						<template v-slot:[`item.actions`]="{ item }">
							<v-btn
								fab
								small
								icon
								elevation="1"
								class="action-btn"
								@click.stop="editReport(item)"
							>
								<v-icon color="info" small>mdi-eye</v-icon>
							</v-btn>
							<v-btn
								v-if="canDeleteReport(item)"
								fab
								small
								icon
								elevation="1"
								class="action-btn"
								@click.stop="deleteReport(item)"
							>
								<v-icon color="error" small>mdi-delete</v-icon>
							</v-btn>
							<div
								v-else
								fab
								small
								icon
								class="v-btn action-btn"
								style="width: 24px; height: 24px; float: right"
							/>
						</template>
					</v-data-table>
				</div>
			</v-container>
		</div>
		<div
			v-if="!isSuperAdmin"
			class="grid-flex-container reportsSection pa-4 px-0"
		>
			<h3>Reports - Visible to me</h3>
			<v-container
				fluid
				class="flexContainerItem pb-0"
				style="overflow: hidden"
			>
				<div class="d-flex">
					<v-text-field
						v-model="searchReports"
						class="py-0 mr-2"
						append-icon="mdi-magnify"
						label="Search"
						single-line
						hide-details
					/>
				</div>
				<div class="generic-grid-container">
					<v-data-table
						dense
						hide-default-footer
						disable-pagination
						fixed-header
						loading-text="Loading..."
						:items="assignedReportPreviews"
						:headers="reportsHeaders"
						:search.sync="searchReports"
						:loading="loading"
					>
						<template v-slot:[`item.actions`]="{ item }">
							<v-btn
								fab
								small
								icon
								elevation="1"
								class="action-btn"
								@click.stop="editReport(item)"
							>
								<v-icon color="info" small>mdi-eye</v-icon>
							</v-btn>
							<v-btn
								v-if="canDeleteReport(item)"
								fab
								small
								icon
								elevation="1"
								class="action-btn"
								@click.stop="deleteReport(item)"
							>
								<v-icon color="error" small>mdi-delete</v-icon>
							</v-btn>
							<div
								v-else
								fab
								small
								icon
								class="v-btn action-btn"
								style="width: 24px; height: 24px; float: right"
							/>
						</template>
					</v-data-table>
				</div>
			</v-container>
		</div>
		<div
			v-if="!isSuperAdmin"
			class="grid-flex-container reportsSection pa-4 pb-0 px-0"
		>
			<h3>Reports - Created by me</h3>
			<v-container
				fluid
				class="flexContainerItem pb-0"
				style="overflow: hidden"
			>
				<div class="d-flex">
					<v-text-field
						v-model="searchReports"
						class="py-0 mr-2"
						append-icon="mdi-magnify"
						label="Search"
						single-line
						hide-details
					/>
				</div>
				<div class="generic-grid-container">
					<v-data-table
						dense
						hide-default-footer
						disable-pagination
						fixed-header
						loading-text="Loading..."
						:items="selfCreatedReportPreviews"
						:headers="reportsHeaders"
						:search.sync="searchReports"
						:loading="loading"
					>
						<template v-slot:[`item.actions`]="{ item }">
							<v-btn
								fab
								small
								icon
								elevation="1"
								class="action-btn"
								@click.stop="editReport(item)"
							>
								<v-icon color="info" small>mdi-eye</v-icon>
							</v-btn>
							<v-btn
								v-if="canDeleteReport(item)"
								fab
								small
								icon
								elevation="1"
								class="action-btn"
								@click.stop="deleteReport(item)"
							>
								<v-icon color="error" small>mdi-delete</v-icon>
							</v-btn>
							<div
								v-else
								fab
								small
								icon
								class="v-btn action-btn"
								style="width: 24px; height: 24px; float: right"
							/>
						</template>
					</v-data-table>
				</div>
			</v-container>
		</div>
		<div
			v-if="isSuperAdmin"
			class="grid-flex-container reportsSection pa-4"
		>
			<v-container
				fluid
				class="flexContainerItem mb-2"
				style="overflow: hidden"
			>
				<div class="d-flex">
					<v-text-field
						v-model="searchReports"
						class="py-0 mr-2"
						append-icon="mdi-magnify"
						label="Search"
						single-line
						hide-details
					/>
				</div>
				<div class="generic-grid-container mt-2">
					<v-data-table
						dense
						hide-default-footer
						disable-pagination
						fixed-header
						loading-text="Loading..."
						:items="adminReportPreviews"
						:headers="reportsHeaders"
						:search.sync="searchReports"
						:loading="loading"
					>
						<template v-slot:[`item.actions`]="{ item }">
							<v-btn
								fab
								small
								icon
								elevation="1"
								class="action-btn"
								@click.stop="editReport(item)"
							>
								<v-icon color="info" small>mdi-eye</v-icon>
							</v-btn>
							<v-btn
								v-if="canDeleteReport(item)"
								fab
								small
								icon
								elevation="1"
								class="action-btn"
								@click.stop="deleteReport(item)"
							>
								<v-icon color="error" small>mdi-delete</v-icon>
							</v-btn>
							<div
								v-else
								fab
								small
								icon
								class="v-btn action-btn"
								style="width: 24px; height: 24px; float: right"
							/>
						</template>
					</v-data-table>
				</div>
			</v-container>
		</div>
		<div class="grid-flex-container reportsSection pa-4">
			<v-container
				fluid
				class="flexContainerItem pb-0"
				style="overflow: hidden"
			>
				<h3>Workbooks</h3>
				<div class="d-flex">
					<v-text-field
						v-model="searchWorkbooks"
						class="py-0 mr-2"
						append-icon="mdi-magnify"
						label="Search"
						single-line
						hide-details
					/>
				</div>
				<div class="generic-grid-container mt-2">
					<v-data-table
						dense
						hide-default-footer
						disable-pagination
						fixed-header
						loading-text="Loading..."
						:items="workbooks"
						:headers="workbooksHeaders"
						:search.sync="searchWorkbooks"
						:loading="loading"
					>
						<template v-slot:[`item.actions`]="{ item }">
							<v-btn
								fab
								small
								icon
								elevation="1"
								class="action-btn"
								@click.stop="previewWorkbook(item)"
							>
								<v-icon color="info" small>mdi-eye</v-icon>
							</v-btn>
							<div
								fab
								small
								icon
								class="v-btn action-btn"
								style="width: 24px; height: 24px; float: right"
							/>
						</template>
					</v-data-table>
				</div>
			</v-container>
		</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import { ReportGetters, AuthGetterTypes } from '../../store/getters';
import { ReportActions } from '../../store/actions';
import { routesNames } from '../../enums/routesNames';
import ConfirmDialog from '@/components/core/dialogs/confirmDialog';

export default {
	name: 'Reports',
	computed: {
		...mapGetters({
			currentUser: [AuthGetterTypes.CURRENT_USER],
			loading: [ReportGetters.LOADING_REPORTS],
			assignedReportPreviews: [ReportGetters.ASSIGNED_REPORT_PREVIEWS],
			selfCreatedReportPreviews: [
				ReportGetters.SELF_CREATED_REPORT_PREVIEWS,
			],
			allVisibleReportPreviews: [
				ReportGetters.ALL_VISIBLE_REPORT_PREVIEWS,
			],
			adminReportPreviews: [ReportGetters.ADMIN_REPORT_PREVIEWS],
			isSuperAdmin: [AuthGetterTypes.IS_SUPERADMIN],
			workbooks: [ReportGetters.ALL_VISIBLE_WORKBOOKS],
		}),

		routeHasParams() {
			if (
				this.$route.params &&
				this.$route.params.reportId &&
				this.$route.params.gridViewId &&
				this.$route.name == routesNames.REPORT_GRID
			)
				return true;
			if (
				this.$route.params &&
				this.$route.params.workbookId &&
				this.$route.name == routesNames.REPORT_WORKBOOK
			)
				return true;
			if (
				this.$route.params &&
				this.$route.params.reportId &&
				this.$route.name == routesNames.REPORT_GRID_CUSTOM
			)
				return true;
			return false;
		},
	},
	data() {
		return {
			searchReports: null,
			searchWorkbooks: null,
			reportsHeaders: [
				{ text: 'Report Name', value: 'ReportName' },
				{ text: 'Data Source', value: 'DataSource' },
				{ text: '', value: 'actions', sortable: false, align: 'end' },
			],
			workbooksHeaders: [
				{ text: 'Workbook Name', value: 'Name' },
				{ text: '', value: 'actions', sortable: false, align: 'end' },
			],
		};
	},

	mounted() {
		if (this.isSuperAdmin) {
			this.$store.dispatch(ReportActions.LOAD_ADMIN_REPORT_PREVIEWS);
		} else {
			this.$store.dispatch(ReportActions.LOAD_REPORT_PREVIEWS);
		}
	},
	methods: {
		editReport(item) {
			if (item.GridViewId == '00000000-0000-0000-0000-000000000000') {
				this.$router.push({
					name: routesNames.REPORT_GRID_CUSTOM,
					params: { reportId: item.ReportId },
				});
			} else {
				this.$router.push({
					name: routesNames.REPORT_GRID,
					params: {
						reportId: item.ReportId,
						gridViewId: item.GridViewId,
					},
				});
			}
		},
		previewWorkbook(item) {
			this.$router.push({
				name: routesNames.REPORT_WORKBOOK,
				params: {
					workbookId: item.Id,
				},
			});
		},
		deleteReport(item) {
			ConfirmDialog({
				message: 'Are you sure you want to delete this item?',
			}).then((isDelete) => {
				if (!isDelete) return;
				this.$store.dispatch(ReportActions.DELETE_REPORT_PREVIEW, item);
			});
		},
		canDeleteReport(report) {
			if (
				report &&
				report.UserId &&
				this.currentUser &&
				report.UserId == this.currentUser.Id
			) {
				return true;
			}
			return false;
		},
	},
};
</script>

<style lang="scss" scoped>
.reportsSection {
	min-height: 240px;
}
.flexContainerItem {
	flex-grow: 0.5;
	overflow: hidden;
	display: flex;
	flex-direction: column;
}
</style>
